// src/components/PrintPriceTagsGrid.js
import React, { useRef, useState, useEffect } from "react";
import { Row, Button } from "reactstrap";

const PrintPriceTagsGrid = ({ tags, emptyColumns }) => {
  const printRef = useRef();
  const [allSourceTags, setAllSourceTags] = useState([]);

  useEffect(() => {
    const repeatedList = [];
    tags.forEach((item) => {
      for (let i = 0; i < item.totalTags; i++) {
        repeatedList.push({ ...item, tagInstance: i + 1 });
      }
    });
    setAllSourceTags(repeatedList);
  }, [tags]);

  const handlePrint = () => {
    const printContent = printRef.current.innerHTML;
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Price Tags</title>
          <style>
            @page {
                size: A4;
                //margin: 0;
                
            }
            body {
              margin: 0;
              padding: 0;
            }
              header, footer {
                display: none;
              }
            .print-font{
                font-size: 20px;
                font-weight: bold;
                padding-top: 2px;
            }

            .tag-code{
                padding-left: 2px;
            }
            .sticker-sheet {
              display: grid;
              grid-template-columns: repeat(5, 38mm);
              grid-template-rows: repeat(13, 21mm);
              //gap: 2mm;
              column-gap: 2mm;
              width: calc(38mm * 5 + 2mm * 4);
              height: calc(21mm * 13);
              margin: auto;
              page-break-inside: avoid;
              page-break-after: always;
            }
            .sticker {
              width: 38mm;
              height: 21mm;
              box-sizing: border-box;
              border: 0.01px solid #eee;
              padding: 2mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              page-break-inside: avoid;
              font-size: 10px;
            }
              .empty-sticker {
              width: 38mm;
              height: 21mm;
              box-sizing: border-box;
              border: 0px solid black;
              padding: 2mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              page-break-inside: avoid;
              font-size: 10px;
            }
            .sticker div {
              width: 100%;
              text-align: center;
            }
            @media print {
            @page {
                size: A4;
                //margin-top: 12mm;
                margin-top: 13mm;
              //margin-bottom: 12mm;
              //margin-left: 6mm;
              margin-left: 4mm;
              margin-right: 4mm;
              }
              body {
                margin: 0;
                padding: 0;
              }
              .sticker-sheet {
                page-break-inside: avoid;
                page-break-after: always;
              }
                header, footer {
                display: none;
              }
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          <div class="sticker-sheet">
            ${printContent}
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <React.Fragment>
      <Row className="mx-5 px-5 mb-2">
        <Button
          color="success"
          className="btn btn-success px-4"
          onClick={handlePrint}
        >
          Print
        </Button>
      </Row>
        <div ref={printRef} className="sticker-sheet">
          {emptyColumns > 0 &&
            Array.from({ length: emptyColumns }).map((_, index) => (
              <div key={index} className="empty-sticker">
              </div>
            ))}
          {allSourceTags.map((tag, index) => (
            <div key={index} className="sticker">
              <div>{tag.productname}{" -"}
                <span className="tag-code">{tag.pRateCode}</span>
              </div>
              <div className="print-font">
                {"₹ "}
                {Number(tag.mrp).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </div>
              
            </div>
          ))}
        </div>
    </React.Fragment>
  );
};

export default PrintPriceTagsGrid;
